import React, { useState, Fragment } from 'react';
import styles from './education.module.scss';
import {useApiData} from "../../hooks/useApiData";
import {mergeData} from "../../utils/data-utils";
import {indexData} from "../../data/data-index";
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';

const options = [
    { label: "Total opportunity score", value: "total" },
    { label: "Earning potential", value: "project" },
    { label: "Career advancement", value: "career" },
    { label: "Top-tier employment prospects", value: "employ" },
    { label: "Premium education", value: "edu" },
    { label: "Economic mobility", value: "econ" },
    { label: "High livability", value: "liva" },
];

const Education = () => {

    const {data, isLoading, error} = useApiData();
    const [sortConfig, setSortConfig] = useState({ key: 'total', direction: 'descending' });

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    const mergedData = mergeData(indexData, data);

    const sortedData = [...mergedData].sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];

        // Handle numbers
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return sortConfig.direction === 'ascending' ? aVal - bVal : bVal - aVal;
        }

        // Handle strings
        if (typeof aVal === 'string' && typeof bVal === 'string') {
            return sortConfig.direction === 'ascending'
                ? aVal.localeCompare(bVal)
                : bVal.localeCompare(aVal);
        }
        return 0;
    });

    const handleOptionSelect = (option) => {
        setSortConfig({ key:option.value, direction:'descending' });
    };

    const handleSort = (columnName) => {

        let direction = 'ascending';
        if (sortConfig.key === columnName && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key:columnName, direction });
    };

    const renderSortArrow = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? <ReverseIconSort /> : <IconSort />;
        }
        return <IconSort />;
    };

    return (
        <>
            {/*<h2 className="mb-5">Explore How You Can Improve Your Opportunity Score via Investment Migration</h2>*/}
            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect} />
            </div>
            <table className={`chartTable ${styles.overviewChartTable}`} >
                <thead>
                <tr>
                    <th className={styles.cityColumn} >Country</th>

                    <th
                        className={
                            `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortConfig.key === 'project' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'project' ? styles.displayColumnTitleDiv : ''}
              `}
                        onClick={() => handleSort("project")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Earning potential</span>
                            {renderSortArrow('project')}
                        </div>
                    </th>
                    <th
                        className={
                            `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortConfig.key === 'career' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'career' ? styles.displayColumnTitleDiv : ''}

              `}
                        onClick={() => handleSort("career")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Career advancement</span>
                            {renderSortArrow('career')}
                        </div>
                    </th>
                    <th
                        className={
                            `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortConfig.key === 'employ' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'employ' ? styles.displayColumnTitleDiv : ''}
              `}
                        onClick={() => handleSort("employ")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Top-tier employment prospects</span>
                            {renderSortArrow('employ')}
                        </div>
                    </th>
                    <th
                        className={
                            `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortConfig.key === 'edu' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'edu' ? styles.displayColumnTitleDiv : ''}

              `}
                        onClick={() => handleSort("edu")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Premium education</span>
                            {renderSortArrow('edu')}

                        </div>
                    </th>

                    <th
                        className={
                            `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortConfig.key === 'econ' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'econ' ? styles.displayColumnTitleDiv : ''}
              `}
                        onClick={() => handleSort("econ")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Economic mobility</span>
                            {renderSortArrow('econ')}
                        </div>
                    </th>
                    <th
                        className={
                            `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortConfig.key === 'liva' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'liva' ? styles.displayColumnTitleDiv : ''}

              `}
                        onClick={() => handleSort("liva")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>High livability</span>
                            {renderSortArrow('liva')}
                        </div>
                    </th>

                    <th
                        className={
                            `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.progressBarColumn}
                              ${sortConfig.key === 'total' ? styles.selectedColumn : ''}
                              ${sortConfig.key === 'total' ? styles.displayColumnTitleDiv : ''}
              `}
                        onClick={() => handleSort("total")}
                    >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Total opportunity score</span>
                            {renderSortArrow('total')}
                        </div>
                    </th>

                    {/* <th className={`text-right ${styles.cellHideMobile}`}>Investment <br/>migration options</th> */}
                </tr>
                </thead>
                <tbody>
                {sortedData.map((item, index) => (
                    // {sortedData.slice(0, numOfCitiesShow).map((item, index) => (
                    <Fragment key={index}>
                        <tr className={`${styles.contentRow} ${styles.openedRow}`}>

                            <td><CountryFlag country={item.country} code={item.ISO2} /></td>

                            <td className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortConfig.key ? styles.selectedColumn : ''} 
                                            ${sortConfig.key === 'total' ? styles.percentColumn : ''}
                                          `}>
                                {sortConfig.key === "total" ?
                                    <ProgressBar
                                        percentValue={item.total > 0 ? item.total : 0}
                                        labelText={formatNumberWithDot(item.total) + "%"}
                                    />
                                    : formatNumberWithDot(item[sortConfig.key])
                                }
                            </td>

                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'project' ? styles.selectedColumn : ''}
                              `}>
                                {formatNumberWithDot(item.project)}
                            </td>
                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'career' ? styles.selectedColumn : ''}
                              `}>
                                {formatNumberWithDot(item.career)}
                            </td>
                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'employ' ? styles.selectedColumn : ''}
                              `}>
                                {formatNumberWithDot(item.employ)}
                            </td>
                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'edu' ? styles.selectedColumn : ''}
                              `}>
                                {formatNumberWithDot(item.edu)}
                            </td>
                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'econ' ? styles.selectedColumn : ''}
                              `}>
                                {formatNumberWithDot(item.econ)}
                            </td>
                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'liva' ? styles.selectedColumn : ''}
                              `}>
                                {formatNumberWithDot(item.liva)}
                            </td>

                            <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortConfig.key === 'total' ? styles.percentColumn : ''}
                                ${sortConfig.key === 'total' ? styles.selectedColumn : ''}
                              `}>
                                <ProgressBar
                                    percentValue={item.total > 0 ? item.total : 0}
                                    labelText={formatNumberWithDot(item.total) + "%"}
                                />
                            </td>

                        </tr>

                    </Fragment>
                ))}


                </tbody>
            </table>


            {/* <div className="footer-note mt-5">
        <ul>
          <li>Figures for June 2023.</li>
          <li>Only includes individuals living in each city (residents).</li>
          <li>'Centi-millionaires' refers to individuals with investable wealth of USD 100 million or more.</li>
        </ul>
        <p>Source: New World Wealth</p>
      </div> */}
        </>
    )
}

export default Education;